import { faCalendar, faClock } from "@fortawesome/free-regular-svg-icons";
import { faBarcode, faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState, useCallback } from "react";
import Style from "./ReceivedOrders.module.css";
import { separate } from "../../Functions/NumberSeprator";
import Factor from "../Factor/Factor";
import Modal from "../Modal/Modal";
import PreparationTime from "../PreparationTime/PreparationTime";
import {
  orderListDetailApi,
  ReceivedOrdersAPI,
} from "../../Api/SupplierServices";
import LoadingComponet from "../LoadingComponet/LoadingComponet";
import { getSupplierInfoAPi, logOutApi } from "../../Api/BarestSupplierServices";
import { useHistory } from "react-router-dom";
import { Check2Circle, Receipt } from "react-bootstrap-icons";
import { splitJalaliDateTime } from "../../Functions/convertDateToJalali";

const ReceivedOrders = () => {
  const [prepareShow, setPrepareShow] = useState(false);
  const [factorShow, setFactorShow] = useState(false);
  const [orders, setOrders] = useState();
  const [orderID, setOrderID] = useState();
  const [orderListDetails, setOrderListDetails] = useState();
  const MINUTE_MS = 30000;
  const history = useHistory();

  const LogoutHandler = () => {
    const info = { logout: "" };
    logOutApi(info, (succ) => {
      console.log(succ);
    });
  };

  // Get supplier info
  const getSupplierInfo = useCallback(async () => {
    const result = await getSupplierInfoAPi();
    if (localStorage.getItem("JwtTokens")) {
      if (result && result.status === -2) {
        LogoutHandler();
        localStorage.clear();
        history.push("/login");
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else if (result && result.info && result.info.lat === "" && result.info.lon === "") {
        setTimeout(() => {
          history.push("/selectaddress");
        }, 0);
      }
    }
  }, [history]);

  const getOrdersList = useCallback(async () => {
    try {
      const data = await ReceivedOrdersAPI();
      if (data && Array.isArray(data.orders)) {
        const sorted = [...data.orders].sort((a, b) => (Number(a.id) > Number(b.id) ? -1 : 1));
        setOrders(sorted);
      } else {
        setOrders([]);
      }
    } catch (err) {
      setOrders([]);
    }
  }, []);

  useEffect(() => {
    getOrdersList();
    getSupplierInfo();
    const interval = setInterval(() => {
      getOrdersList();
    }, MINUTE_MS);
    return () => clearInterval(interval);
  }, [getOrdersList, getSupplierInfo]);

  const getOrderListsDetail = async (id) => {
    try {
      const data = await orderListDetailApi(id);
      setOrderListDetails(data);
    } catch (err) {
      setOrderListDetails({ products: [] });
    }
  };

  const FactorListHandler = (id) => {
    setOrderID(id);
    setOrderListDetails(undefined); // Reset so previous order data is not flashed
    setFactorShow(true);
    getOrderListsDetail(id);
  };

  const setTimePreparation = (id) => {
    setPrepareShow(true);
    setOrderID(id);
  };

  let loadingHandler = null;
  if (orders === undefined) {
    loadingHandler = <LoadingComponet />;
  } else if (orders.length === 0) {
    loadingHandler = (
      <div className={Style.NotOrderFoundHolder}>
        <div className={Style.ImageBasket}>
          <img src="/Assets/Images/Order/emtyOreder.svg" alt="barest" />
        </div>
        <p className={Style.NoOrderText}>سفارشی یافت نشد</p>
      </div>
    );
  } else {
    // Reverse safely for all environments
    const displayedOrders = Array.isArray(orders) ? [...orders] : [];
    loadingHandler = displayedOrders.map((item, index) => {
      const { date: orderDate, time: orderTime } = splitJalaliDateTime(item.date);
      return (
        <div key={item.id || index} className={Style.orderCard}>
          {/* Card Top: Date & Time */}
          <div className={Style.cardHeader}>
            <div className={Style.dateBadge}>
              <FontAwesomeIcon icon={faCalendar} />
              <span>{orderDate}</span>
            </div>
            <div className={Style.timeBadge}>
              <FontAwesomeIcon icon={faClock} />
              <span>{orderTime}</span>
            </div>
          </div>

          {/* Card Body: Info Fields */}
          <div className={Style.cardBody}>
            <div className={Style.infoRow}>
              <span className={Style.infoLabel}>
                <FontAwesomeIcon icon={faBarcode} /> کد پیگیری:
              </span>
              <span className={Style.trackingCode}>{item.id}</span>
            </div>

            <div className={Style.infoRow}>
              <span className={Style.infoLabel}>
                <FontAwesomeIcon icon={faMoneyBillWave} /> مبلغ کل:
              </span>
              <span className={Style.totalPrice}>
                {separate(item.cart)} تومان
              </span>
            </div>

            <div className={Style.infoRow}>
              <span className={Style.infoLabel}>
                <FontAwesomeIcon icon={faMoneyBillWave} /> کمیسیون:
              </span>
              <span className={Style.feePrice}>
                {separate(item.cart_fee)} تومان
              </span>
            </div>
          </div>

          {/* Card Actions */}
          <div className={Style.cardActions}>
            <button
              type="button"
              className={Style.confirmBtn}
              onClick={() => setTimePreparation(item.id)}
            >
              <Check2Circle className={Style.btnIcon} />
              <span>قبول سفارش</span>
            </button>

            <button
              type="button"
              className={Style.factorListBtn}
              onClick={() => FactorListHandler(item.id)}
            >
              <Receipt className={Style.btnIcon} />
              <span>لیست سفارش</span>
            </button>
          </div>
        </div>
      );
    });
  }

  return (
    <div className={Style.ComponentHolder}>
      {/* Factor Modal */}
      <Modal
        show={factorShow}
        modalClose={() => setFactorShow(false)}
        translate={40}
      >
        <Factor orderID={orderID} data={orderListDetails} />
      </Modal>

      {/* Preparation Time Modal */}
      <Modal
        show={prepareShow}
        modalClose={() => setPrepareShow(false)}
        translate={40}
      >
        <PreparationTime
          orderID={orderID}
          closemodal={() => setPrepareShow(false)}
        />
      </Modal>

      <div className={Style.ordersGrid}>{loadingHandler}</div>
    </div>
  );
};

export default ReceivedOrders;
